import Raven from 'raven-js';

const { ENV: environment, ASSETS_HASH: release } = process.env;

if (environment !== 'docker') {
  const shopRebootDsn =
    'https://4a7c39feab8b475aa16a2ccc5d09641f@sentry.io/1407539';
  const sentryProjects = {
    plp: {
      regex: /(kategorie|categorie|categoria)/,
      dsn: 'https://8c0a5ff1ff80420e997611de619ff86d@sentry.io/1407543'
    },
    pdp: {
      regex: /(produkt|product|article|prodotto)/,
      dsn: 'https://ad5539bf2a48438ba221504319f4f9e6@sentry.io/1407541'
    },
    'cart-and-checkout': {
      regex: /(checkout)/,
      dsn: 'https://37fbe9f5eceb45f88a26b9eca06b2740@sentry.io/1407546'
    },
    'my-account': {
      regex: /(meinkundenkonto|mon-compte|mijnaccount|ilmioaccount|myaccount|artikelauswahl|anfragegrund|info|success|artikelkeuze|aanvraagreden|scelta-articolo|motivo-richiesta|selectionarticle|objetrequete)/,
      dsn: 'https://20772ae30c774eefad5d58de06ce01ae@sentry.io/1407547'
    },
    help: {
      regex: /(hilfebereich|aide-faq|assistentie|assistenza)/,
      dsn: 'https://1d6554983c604db0930ca2a35ac76b0e@sentry.io/1407548'
    }
  };
  const url = window.location.href;

  let sentryProjectDsn = shopRebootDsn; // default sentry project
  for (const key in sentryProjects) {
    if (url.match(sentryProjects[key].regex)) {
      sentryProjectDsn = sentryProjects[key].dsn;
      break;
    }
  }
  Raven.config(sentryProjectDsn, {
    release,
    environment
  }).install();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/sentry.js
 **/